import React, { memo, useRef } from 'react';
import { pdfStyles } from '../../pdfStyles';
import { Page, View } from '@react-pdf/renderer';
import {
  Footer,
  FooterStartComponent,
  Header,
  HeaderEndComponent,
  IncidentPage,
  IncidentsTable,
  NoData,
  TitleLink,
} from '../../comps';
import { isEqual } from 'lodash';
import { ActionsConf, AssessmentPDF, AssessmentIncidentPDF, TocItem } from '../../types';
import { ColorSet } from 'src/redux/reducers/theme';

interface IncidentsRenderProps {
  assessment: AssessmentPDF;
  onDone: (pageNumber: number, toc: TocItem[]) => void;
  incidents: AssessmentIncidentPDF[];
  colors: ColorSet;
  includesActions: ActionsConf;
  logoSrc?: string;
  secondaryColor?: string | null;
}

export const IncidentsRender: React.FC<IncidentsRenderProps> = memo(
  ({ assessment, onDone, incidents, colors, includesActions, logoSrc, secondaryColor }) => {
    const mainPageNumber = useRef(0);

    const list: { [key: string]: TocItem } = {};

    const onRender = (pageNumber: number, idx: number, title: string) => {
      list[idx] = { pageNumber: pageNumber, title };

      if (idx === incidents.length - 1) {
        const outputArray = Object.keys(list).map((key) => list[key]);
        onDone(mainPageNumber.current, outputArray);
      }
    };

    return (
      <>
        <Page size={'A4'} wrap style={pdfStyles.page}>
          <Header endComponent={<HeaderEndComponent title="BACK TO TOP" />} colors={colors} logoSrc={logoSrc} />
          <View
            // @ts-ignore
            render={(data) => {
              if (!incidents.length) {
                onDone(data.pageNumber, []);
              } else {
                mainPageNumber.current = data.pageNumber;
              }
            }}
          />
          <View style={pdfStyles.section}>
            <TitleLink title={'INCIDENTS'} intLinkId={'incidents'} extLink={`incidents`} colors={colors} />

            <View style={pdfStyles.spacer8} />
            <View style={pdfStyles.spacer4} />
            {incidents.length ? <IncidentsTable data={incidents} colors={colors} /> : <NoData colors={colors} />}
          </View>

          <Footer footerComponent={<FooterStartComponent title={`${assessment.name} / Incidents`} />} colors={colors} />
        </Page>
        {incidents.map((el, idx) => {
          return (
            <IncidentPage
              key={el.id}
              incident={el}
              onRender={(pageNumber) => onRender(pageNumber, idx, el.name)}
              endComponent={<HeaderEndComponent title="BACK TO TOP" />}
              footerComponent={<FooterStartComponent title={`${assessment.name} / Incidents / ${el.name}`} />}
              colors={colors}
              includesActions={includesActions}
              logoSrc={logoSrc}
              secondaryColor={secondaryColor}
            />
          );
        })}
      </>
    );
  },
  (prevProps, nextProps) => isEqual(prevProps, nextProps),
);
